export const CART_DETAILS_GET_REQUEST = 'CART_DETAILS_GET_REQUEST';
export const CART_DETAILS_GET_REQUEST_SUCCESS = 'CART_DETAILS_GET_REQUEST_SUCCESS';
export const UPDATE_APPLE_ELIGIBILITY = 'UPDATE_APPLE_ELIGIBILITY';
export const CART_DETAILS_GET_ERROR = 'CART_DETAILS_GET_ERROR';

export const SAVE_FOR_LATER_REQUEST = 'SAVE_FOR_LATER_REQUEST';
export const SAVE_FOR_LATER_REQUEST_SUCCESS = 'SAVE_FOR_LATER_REQUEST_SUCCESS';
export const SAVE_FOR_LATER_REQUEST_ERROR = 'SAVE_FOR_LATER_REQUEST_ERROR';

export const VERTICAL_SFL_VIEW_ALL = 'VERTICAL_SFL_VIEW_ALL';

export const REMOVE_SAVED_ITEM_SUCCESS = 'REMOVE_SAVED_ITEM_SUCCESS';

export const CART_ITEM_QUANTITY_UPDATE_REQUEST = 'CART_ITEM_QUANTITY_UPDATE_REQUEST';

export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const STORE_REMOVED_CART_ITEM = 'STORE_REMOVED_CART_ITEM';
export const DELETE_STORED_CART_ITEM = 'DELETE_STORED_CART_ITEM';
export const REMOVE_CART_ITEM_ERROR = 'REMOVE_CART_ITEM_ERROR';

export const RESET_MOVE_CART_SFL_SUCCESS = 'RESET_MOVE_CART_SFL_SUCCESS';
export const RESET_MOVE_SFL_CART_SUCCESS = 'RESET_MOVE_SFL_CART_SUCCESS';

export const ITEM_FULFILLMENT_UPDATE_REQUEST = 'ITEM_FULFILLMENT_UPDATE_REQUEST';
export const ITEM_FULFILLMENT_UPDATE_ERROR = 'ITEM_FULFILLMENT_UPDATE_ERROR';

export const GET_CART_ITEMS = 'GET_CART_ITEMS';
export const GET_ORDER_INFO = 'GET_ORDER_INFO';
export const GET_ORDER_ADJUSTMENTS = 'GET_ORDER_ADJUSTMENTS';
export const GET_ORDER_CHARGES = 'GET_ORDER_CHARGES';
export const GET_ORDER_TOTALS = 'GET_ORDER_TOTALS';
export const GET_CERTONA_ATTRIBUTES = 'GET_CERTONA_ATTRIBUTES';

export const LOAD_EMPTY_CART = 'LOAD_EMPTY_CART';
export const UPDATE_ANALYTICS_CLICK_EVENT = 'UPDATE_ANALYTICS_CLICK_EVENT';
export const UPDATE_CART_IN_PROGRESS = 'UPDATE_CART_IN_PROGRESS';

export const GET_MARKETING_SLOT_BANNER = 'GET_MARKETING_SLOT_BANNER';
export const GET_MARKETING_SLOT_BANNER_SUCCESS = 'GET_MARKETING_SLOT_BANNER_SUCCESS';
export const GET_MARKETING_SLOT_BANNER_ERROR = 'GET_MARKETING_SLOT_BANNER_ERROR';
export const SET_PLCC_DYNAMIC_BANNER = 'SET_PLCC_DYNAMIC_BANNER';
export const GET_PLCC_BANNER_HTML = 'GET_PLCC_BANNER_HTML';
export const GET_PLCC_DETAILS_HTML = 'GET_PLCC_DETAILS_HTML';
export const SET_PLCC_BANNER_HTML = 'SET_PLCC_BANNER_HTML';
export const SET_PLCC_DETAILS_HTML = 'SET_PLCC_DETAILS_HTML';

export const ITEMS_QUANTITY_CHANGED = 'ITEMS_QUANTITY_CHANGED';

export const GET_GIFT_CARD_BALANCE = 'GET_GIFT_CARD_BALANCE';
export const UPDATE_GIFT_CARD = 'UPDATE_GIFT_CARD';
export const SET_GIFT_CARD_ERROR = 'SET_GIFT_CARD_ERROR';

export const GET_IRIS_MARKETING_SLOT_BANNER = 'GET_IRIS_MARKETING_SLOT_BANNER';

export const UPDATE_LOW_STOCK_NUDGE_ALERT_ITEM = 'UPDATE_LOW_STOCK_NUDGE_ALERT_ITEM';
export const WEB_GET_REWARD_PROFILE_REQUEST_POINTS_EARNED =
    'WEB_GET_REWARD_PROFILE_REQUEST_POINTS_EARNED';

export const LOG_META_UA = 'LOG_META_UA';
